import React, { Component } from 'react';
import Swiper from 'swiper';

export default class TeamSlider extends Component {
  componentDidMount() {
    new Swiper('.team-slider', {
      speed: 400,
      // spaceBetween: 35,
      slidesPerView: 'auto',
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        init: function() {
          this.lazy.loadInSlide(0);
          this.lazy.loadInSlide(1);
          this.lazy.loadInSlide(2);
          this.lazy.loadInSlide(3);
        },
        resize: function() {
          if (this.width <= 768) {
            this.params.slidesPerView = 'auto';
          }
        }
      }
    });
  }

  render() {
    const content = this.props.children;

    return (
      <div className="team-slider swiper-container flex">
        <div className="swiper-wrapper">
          {content ? content : <p>Geen content voor slider beschikbaar</p>}
        </div>
        <div className="swiper-button-container">
          <div className="swiper-button-prev">
            <span />
            <span />
            <span />
          </div>
          <div className="swiper-button-next">
            <span />
            <span />
            <span />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TeamSlider/TeamSlider.jsx